import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux'

import FormControl from '@material-ui/core/FormControl';
import SearchOutlined from '@material-ui/icons/FindInPageOutlined';
import CloudDownload from '@material-ui/icons/CloudDownload';
import DeleteForever from '@material-ui/icons/DeleteForever';
import CircularProgress from '@material-ui/core/CircularProgress';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { openConfirmSnackBar } from '../../actions'
import { store } from '../../store';


import Title from './Title';
import Edit from '@material-ui/icons/Edit';

const validate = values => {
    const errors = {}
    const requiredFields = [
        'cuenta',
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required'
        }
    })
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address'
    }
    if (values.cuenta && values.cuenta.length !== 9) {
        errors.cuenta = 'No. de cuenta no valido.'
    }
    return errors
}

const renderTextFieldb = (
    { input, label, meta: { touched, error }, ...custom },
) => (
        <TextField
            //hintText={label}
            //floatingLabelText={label}
            //errorText={touched && error}
            {...input}
            {...custom}
        />
    );

const renderTextField = ({
    label, name, type,
    input,
    meta: { touched, invalid, error }

}) => (
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}

            variant="outlined"
            margin="normal"

            fullWidth
            type={type}
            //id={name}

            autoComplete={name}
        />
    )


//const FrmConsulta = ({ classes, handleSubmit, submitting, onBack, pristine, submitSucceeded }) => {
let FrmConsulta = props => {
    const { handleSubmit, pristine, reset, submitting, classes, busqueda } = props;

    function handleOpenGrupo() {

        //const value = selector(state, 'busqueda')

        console.log("vuamos con el cambio de clave:   " + busqueda);

        //setOpenGrupo(true);
    }

    const frmConsultaState = props.apiFetch.FrmConsulta === undefined ? 'init' : props.apiFetch.FrmConsulta;

    let registros;
    var tmpDatos = [];

    if (!(props.apiFetch.getProcesos === undefined)) {
        if (props.apiFetch.getProcesos.length === 0) {
            registros = 0;
            tmpDatos = [...tmpDatos, ...tmpDatos];
        }
        else {
            registros = props.apiFetch.getProcesos.length;
            tmpDatos = [...tmpDatos, ...props.apiFetch.getProcesos];
            console.log(tmpDatos);
            console.log("Regs:" + registros);

        }
    }
    else {
        registros = 0;
        tmpDatos = [...tmpDatos, ...tmpDatos];
    }


    const logueado = props.loggedIn === undefined ? false : props.loggedIn;
    console.log("logueado: " + logueado);


    const handleQuitar = (cta, props) => {
        //alert("vuamos con :" + cta + "u:" + 

        store.dispatch(openConfirmSnackBar(cta));
    }

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <Grid item sm={6} style={{ margin: '0 auto' }} >
                <FormControl variant="outlined" className={classes.formControl} margin="normal" fullWidth >
                    <Field name="busqueda" component={renderTextField} label="Buscar" type="text" autoFocus />
                </FormControl>
                {frmConsultaState === 'fetching' ? <CircularProgress className={classes.progress} /> : ''}
            </Grid>

            <Grid container>
                <Grid item xs >
                    <p href="#" variant="body2">Ej. Reparación directa, ministerio de defensa</p>
                </Grid>

            </Grid>

            {registros > 0 ? <Paper className={classes.paper}>

                <React.Fragment>

                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>RADICADO DEL PROCESO</TableCell>
                                <TableCell>FECHA</TableCell>
                                <TableCell>INSTACIA</TableCell>
                                <TableCell>MAGISTRADO</TableCell>
                                <TableCell>DEMANDANTE</TableCell>
                                <TableCell>DEMANDADO</TableCell>
                                <TableCell>MEDIO DE CONTROL</TableCell>
                                <TableCell>DESCRIPTOR</TableCell>
                                <TableCell>RESTRICTOR</TableCell>
                                <TableCell>DECISIÓN</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tmpDatos.map(row => (
                                <TableRow className={classes.gridDia} key={row.codproceso}>
                                    <TableCell onClick={() => window.open(`http://www.ramajudicialdelhuila.gov.co/PortalREST/uploads/archivos/${row.folder}/${row.expediente}${row.extarchivo}`, "_blank")}><CloudDownload /></TableCell>
                                    <TableCell >{row.codproceso}</TableCell>
                                    <TableCell >{row.fecha}</TableCell>
                                    <TableCell >{row.descripcioninstancia}</TableCell>
                                    <TableCell >{row.magistrado}</TableCell>
                                    <TableCell >{row.demandante}</TableCell>
                                    <TableCell >{row.demandado}</TableCell>
                                    <TableCell >{row.descripcionaccion}</TableCell>
                                    <TableCell >{row.descripciondescriptor}</TableCell>
                                    <TableCell >{row.descripcionrestrictor}</TableCell>
                                    <TableCell >{row.descripciondecision}</TableCell>
                                    {logueado ? <TableCell><DeleteForever onClick={() => { handleQuitar('Está seguro(a) de quitar : ' + row.codproceso + ',quitarProvidencia,' + row.codproceso, props) }}></DeleteForever>  </TableCell> : <TableCell></TableCell>}

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </React.Fragment>
            </Paper> : ''}
        </form>
    );
};

FrmConsulta.propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    //age: PropTypes.number,
    //onBack: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
    //se filta de una lista a un solo elemnto como propiedad
    //tercero: getUsuarioState(state)    


    //snackBarMensaje: state.SnackBar,

});

// Decorate with redux-form
FrmConsulta = reduxForm({
    form: 'FrmConsulta'  // a unique identifier for this form
})(FrmConsulta)

// Decorate with connect to read form values
const selector = formValueSelector('FrmConsulta') // <-- same as form name
FrmConsulta = connect(
    state => {
        // can select values individually
        const busqueda = selector(state, 'busqueda');
        const apiFetch = state.apiFetch;
        const loggedIn = state.auth.loggedIn;
        const snackBar = state.snackBar;
        //const favoriteColorValue = selector(state, 'favoriteColor')
        // or together as a group
        //const { firstName, lastName } = selector(state, 'firstName', 'lastName')
        return {
            busqueda, apiFetch, loggedIn, snackBar
            //favoriteColorValue,
            //fullName: `${firstName || ''} ${lastName || ''}`
        }
    }
)(FrmConsulta)

export default FrmConsulta


